import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Признак активности", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Битовая маска компании", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Дата", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_CheckBoxControl = _resolveComponent("CheckBoxControl")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_DateControl = _resolveComponent("DateControl")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    ref: "dialog"
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_TextControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Наименование...",
          "show-clear-button": true,
          value: model.name,
          "onUpdate:value": ($event: any) => ((model.name) = $event),
          hasEmptyValue: false,
          validationGroup: validationGroup
        }, null, 8, ["value", "onUpdate:value", "validationGroup"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_2,
        _createVNode(_component_CheckBoxControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Признак активности",
          value: model.isActive,
          "onUpdate:value": ($event: any) => ((model.isActive) = $event),
          hasEmptyValue: false,
          validationGroup: validationGroup
        }, null, 8, ["value", "onUpdate:value", "validationGroup"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_3,
        _createVNode(_component_IntegerControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Битовая маска компании",
          min: 0,
          value: model.modulesMask,
          "onUpdate:value": ($event: any) => ((model.modulesMask) = $event),
          hasEmptyValue: false,
          validationGroup: validationGroup
        }, null, 8, ["value", "onUpdate:value", "validationGroup"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _createVNode(_component_DateControl, {
          class: "ModelField-control",
          value: model.licenseExpirationDate,
          "onUpdate:value": ($event: any) => ((model.licenseExpirationDate) = $event),
          mode: "datetime",
          stylingMode: "outlined",
          hasEmptyValue: false,
          readOnly: false,
          validationGroup: validationGroup
        }, null, 8, ["value", "onUpdate:value", "validationGroup"])
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback"]))
}